import { render, staticRenderFns } from "./itemPreview.vue?vue&type=template&id=515f51db&"
import script from "./itemPreview.vue?vue&type=script&lang=js&"
export * from "./itemPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports